import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          data-testid="scroll-to-top-btn"
          className="fixed bottom-8 right-8 z-40 w-14 h-14 bg-[#127abb] hover:bg-[#0e6292] text-white rounded-full shadow-2xl hover:shadow-[#127abb]/50 flex items-center justify-center transition-all duration-300 hover:scale-110 animate-in fade-in slide-in-from-bottom"
          aria-label="Retour en haut"
        >
          <ArrowUp size={24} strokeWidth={2.5} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;